<form
  [formGroup]="form"
  class="form-group"
  [ngClass]="{
    'form-error': form.get('adresse').invalid
  }"
>
  <div class="autocomplete-container">
    <label class="form-label required">{{ 'Adresse' | tekstresource }}</label>
    <span class="form-hint" id="input-hint-message-input-type-text">
      {{ 'Kontaktoplysninger.Adresse.Beskrivelse' | tekstresource }}</span
    >
    <span
      *ngIf="form.get('adresse').invalid"
      class="form-error-message"
      id="form-error-message-form-error"
      role="alert"
    >
      <ng-container *ngIf="form.get('adresse').hasError('message')">
        {{ form.get('adresse').errors['message'] }}
      </ng-container>
    </span>

    <div class="col-7">
      <input
        bomCustomValidationMessage
        validationMsg="{{ 'Kontaktoplysninger.Adresse.IkkeValid' | tekstresource }}"
        formControlName="adresse"
        id="adresse"
        #input
        type="text"
        class="form-input"
        [placeholder]="'SkrivAdresse' | tekstresource"
        (blur)="onBlur()"
      />
    </div>
  </div>
</form>
